import { Navigate } from 'react-router';
import { useSessionStore } from '@/auth/session.store';
import { zoneHome } from '@/auth/zone-home';

/**
 * `/` — kullaniciyi kendi bolgesine birakir.
 *
 * Karar zoneHome'dan geliyor; giris sonrasi yonlendirme ve RequireZone ile AYNI
 * fonksiyon. Ikinci bir kopya, "girince dogru yere gidiyor ama adres cubuguna
 * '/' yazinca baska yere dusuyor" turunden bir tutarsizlik uretirdi.
 */
export function RootRedirect() {
  const status = useSessionStore((state) => state.status);
  const snapshot = useSessionStore((state) => state.snapshot);

  // Soguk acilis surerken karar VERILMEZ: burada '/giris'e gonderilseydi,
  // sessiz yenileme basarili olsa bile kullanici giris ekranini gorurdu.
  if (status === 'hydrating') return null;
  if (!snapshot) return <Navigate to="/giris" replace />;
  return <Navigate to={zoneHome(snapshot)} replace />;
}
